<ng-container *nfLoader="loading"
  ><nf-table-layout
    class="cash-entry-matches-table"
    hideTitle
    [isSectionTitle]="false"
    [gridOptions]="gridOptions"
    [data]="rowData"
    hideSearch
    [autoResizeGrid]="false"
    hideClearAll
  ></nf-table-layout>
</ng-container>
